import { FeeNature } from "../enums/FeeNature";

export const useDummyDigestOrders = false;

export const flowDigestOrders = [
    {
        id: 1,
        order_number: "MY0000009031",
        date_time: "2023-11-19 20:07:33",
        customer: "Ali Tan",
        amount: 50,
        tax_amount: 3,
        fee_types: [{
            id: 1,
            name: 'Sales',
            description: null,
            nature: FeeNature.INCOME,
            amount: 61,
        },
        {
            id: 2,
            name: 'Discount',
            description: null,
            nature: FeeNature.INCOME,
            amount: 11,
        },
        ],
        payment_methods: [{
            id: 1,
            name: 'Credit Card',
            description: null,
            amount: 22,
        },
        {
            id: 2,
            name: 'Debit Card',
            description: null,
            amount: 109,
        },
        ],
        created_at: "2023-11-19 20:07:33",
        updated_at: "2023-11-19 20:07:33",
    },
    {
        id: 2,
        order_number: "MY0000009032",
        date_time: "2023-11-19 20:07:33",
        customer: "Ali Tan 2",
        amount: 87,
        tax_amount: 3,
        fee_types: [{
            id: 1,
            name: 'Shipping',
            description: null,
            nature: FeeNature.EXPENSE,
            amount: 22,
        },
        {
            id: 2,
            name: 'Discount',
            description: null,
            nature: FeeNature.INCOME,
            amount: 109,
        },
        ],
        payment_methods: [{
            id: 1,
            name: 'Credit Card',
            description: null,
            amount: 22,
        },
        {
            id: 2,
            name: 'Debit Card',
            description: null,
            amount: 109,
        },
        ],
        created_at: "2023-11-19 20:07:33",
        updated_at: "2023-11-19 20:07:33",
    },
];

export const flowDigestOrdersPagination = {
    total: 2,
    current_page: 1,
    per_page: 30,
};
